import React from 'react';
import merge from 'deepmerge';
import { Observe } from 'rewire-core';
import { withTheme } from '../utility/styles';
import { Grid as RewireGrid, GridProps as RewireGridProps, IGridColors, IGridFontSizes, IGridProps } from 'rewire-grid';

import './gridCssStyles.css';

class Grid extends React.Component<RewireGridProps> {
  render() {
    const { grid, gridColors, gridFontSizes, ...props } = this.props;

    const defaultGridColors: IGridColors = {
      headerBackground: this.props.theme!.palette.dialogPrimary.main,
      rowSelectedBorder: '#d0d0d0',
      gridBorder: '#d0d0d0',
      gridText: this.props.theme!.palette.neutral.dark,
      cellOutline: this.props.theme!.palette.secondary.main,
    };

    const defaultIGridFontSizes: IGridFontSizes = {
      header: '0.95em',
      body: '0.9em',
      groupRow: '1em',
      toggleMenu: '0.95em',
    };

    const gridColorsToUse = merge(defaultGridColors, gridColors || {});
    const gridFontSizesToUse = merge(defaultIGridFontSizes, gridFontSizes || {});

    return (
      <Observe
        render={() => <RewireGrid grid={grid} gridColors={gridColorsToUse} gridFontSizes={gridFontSizesToUse} {...props} />}
      />
    );
  }
}

export default withTheme<IGridProps>(Grid);
